// extracted by mini-css-extract-plugin
export var arrows = "_p-5";
export var decrementer = "_p-9";
export var disabled = "_p-3";
export var error = "_p-1";
export var hiddenText = "_p-a";
export var incrementer = "_p-8";
export var input = "_p-7";
export var inputWrapper = "_p-0";
export var readonly = "_p-2";
export var regular = "_p-6";
export var small = "_p-4";